import { defineStore } from 'pinia';
import axios from 'axios';

type SettingsState = {
  chatAgentWorkspaceMemory: string | undefined; // undefined = not fetched yet
  chatAgentWorkspaceMemoryError: string | undefined;
};

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsState => ({
    chatAgentWorkspaceMemory: undefined,
    chatAgentWorkspaceMemoryError: undefined,
  }),
  getters: {
    getChatAgentWorkspaceMemory: (state) => state.chatAgentWorkspaceMemory,
    getChatAgentWorkspaceMemoryError: (state) =>
      state.chatAgentWorkspaceMemoryError,
  },
  actions: {
    async fetchChatAgentWorkspaceMemory() {
      this.chatAgentWorkspaceMemoryError = undefined;
      try {
        const res = await axios.get('/api/v2/agents/chat/memory/workspace');
        this.chatAgentWorkspaceMemory = res.data.memory;
        return this.chatAgentWorkspaceMemory;
      } catch (error: any) {
        this.chatAgentWorkspaceMemoryError =
          error?.response?.data?.message || 'Failed to load workspace memory';
        throw error;
      }
    },
    async updateChatAgentWorkspaceMemory(memory: string) {
      this.chatAgentWorkspaceMemoryError = undefined;
      try {
        const res = await axios.put('/api/v2/agents/chat/memory/workspace', {
          memory,
        });
        this.chatAgentWorkspaceMemory = res.data.memory;
        return this.chatAgentWorkspaceMemory;
      } catch (error: any) {
        this.chatAgentWorkspaceMemoryError =
          error?.response?.data?.message || 'Failed to save workspace memory';
        throw error;
      }
    },
  },
});
